import { useSinglePole } from "../../../../hooks"



export default function PoleNamePresenter() {
   const {singlePoleQuery:{data, isLoading}} = useSinglePole();

   if(isLoading){
    return <>...</>
   }
  return (
    <>{data?.pole_name}</>
  )
}
